module.exports = __webpack_public_path__ + "static/img/17.96e08f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/17.png
// module id = r+A2
// module chunks = 0